import * as duck from './duck';
import { FULL_PERMISSIONS_LIST, ACCOUNT_PERMISSIONS_LIST } from './constants';
import modifiers from './configurations';

const setGeneralPermissions = (grantedPermissions = [], context = {}) => (dispatch) => {
    let permissions = {};

    modifiers.forEach(modifier => {
        permissions = modifier.apply(permissions, grantedPermissions, context);
    });

    dispatch(duck.setGeneralPermissions(permissions, grantedPermissions));
}

const setResourcePermissions = (resourceType, resourceList = [], context = {}) => (dispatch) => {

    let permissions = {};
    const rawPermissions = [];

    const key = context.resourceKey || "id";

    resourceList.forEach((r) => {
        let resourcePermissions = {};
        const grantedPermissions = r.permissions || [];
        rawPermissions.push(...grantedPermissions);

        // We only need the default modifier for resource permissions
        // because the other modifiers are for general permissions only
        // and do not apply to resource-specific permissions
        resourcePermissions = modifiers[0].apply(
                resourcePermissions,
                grantedPermissions,
                context
            );

        permissions[r[key]] = resourcePermissions;
    });

    dispatch(duck.setResourcePermissions(resourceType, permissions, rawPermissions));
}

const addResourcePermission = (resourceType, resourceId, permissions) => (dispatch) => {
    dispatch(duck.addResourcePermission(resourceType, resourceId, permissions));
};

const removeResourcePermission = (resourceType, resourceId) => (dispatch) => {
    dispatch(duck.removeResourcePermission(resourceType, resourceId));
};

const clear = () => (dispatch) => {
    dispatch(duck.clearPermissions());
}

const can = (resource, action, context = {}) => (dispatch, getState) => {
    const state = getState();
    return duck.Selectors.can(state, resource, action, context);
}

export default {
    thunks: {
        setGeneralPermissions,
        setResourcePermissions,
        addResourcePermission,
        removeResourcePermission,
        clear,
        can
    },
    selectors: {
        isLoaded: duck.Selectors.isLoaded,
        can: duck.Selectors.can,
        map: duck.Selectors.getMap,
    },
    checkPermission: duck.checkPermission,
    FULL_PERMISSIONS_LIST,
    ACCOUNT_PERMISSIONS_LIST,
}